export const TAP_MOVE_TOLERANCE = 8;

export function createPointerGesture(point, now = Date.now()) {
  return { x: point.x, y: point.y, lastX: point.x, lastY: point.y, moved: 0, time: now };
}

export function movePointerGesture(gesture, point) {
  const dx = point.x - gesture.lastX, dy = point.y - gesture.lastY;
  const wasDragging = gesture.moved > TAP_MOVE_TOLERANCE;
  gesture.moved = Math.max(gesture.moved, Math.hypot(point.x - gesture.x, point.y - gesture.y));
  gesture.lastX = point.x; gesture.lastY = point.y;
  return { dx, dy, startedDrag: !wasDragging && gesture.moved > TAP_MOVE_TOLERANCE };
}

export function isPointerTap(gesture, { mouse = false, maxDuration = 450, now = Date.now() } = {}) {
  return Boolean(gesture && !gesture.pinch && gesture.moved <= TAP_MOVE_TOLERANCE
    && (mouse || now - gesture.time < maxDuration));
}
